import { render, staticRenderFns } from "./actividad_economica.vue?vue&type=template&id=4fdcf484"
import script from "./actividad_economica.vue?vue&type=script&lang=js"
export * from "./actividad_economica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports